import { IExpenseSummary, IRecoverableExpenseUpdate, OperatingExpense } from "views/ProFormaTable/types"
import { RecoverableExpenses } from "./types"

export const initFromExpenses = (expenses: IExpenseSummary): RecoverableExpenses => {
    const all = [
        ...(expenses.operatingExpenses ?? []),
        ...(expenses.propertyTaxesOperatingExpense ?
            [expenses.propertyTaxesOperatingExpense] : []),
    ]

    return Object.fromEntries(
        all.map(e => [e.id, {
            isRecoverable: e.isRecoverable ?? false,
            recoverablePercentage: e.recoverablePercentage ?? 0,
        }])
    )
}

export const buildDelta = (                                                         
    recoverableExpenses: RecoverableExpenses,                                                
    allExpenses: OperatingExpense[],                                         
): IRecoverableExpenseUpdate[] => allExpenses.flatMap(exp => {               
    const row = recoverableExpenses[exp.id];                                                
    if (!row) return [];                                                   
                                                                             
    const serverIsRec = exp.isRecoverable ?? false;                          
    const serverPct = exp.recoverablePercentage ?? 0;
                                                                             
    const changed = row.isRecoverable !== serverIsRec                        
        || row.recoverablePercentage !== serverPct;                          
                                                                             
    return changed
        ? [{
            id: exp.id,
            isRecoverable: row.isRecoverable ?? false,
            recoverablePercentage: row.recoverablePercentage ?? 0,
        }]
        : [];
});